<template>
    <div
        class="custom-icon-button"
        @click="$emit('btnClicked')"
        @mouseover="isHovered = true"
        @mouseleave="isHovered = false"
    >
        <div
            class="custom-icon-container"
            :style="{
                width: width,
                height: height,
                padding: padding,
                border: border,
                borderRadius: radius,
                'background-color': hoveredFeature ? (isHovered ? hoveredBgColor : bgColor) : bgColor,
            }"
        >
            <DynamicSvg :name="iconName" :color="iconColor" />
        </div>
    </div>
</template>
<script>
import DynamicSvg from "./DynamicSvg.vue";

export default {
    name: "IconButton",
    components: { DynamicSvg },
    props: {
        iconName: { type: String, required: true },
        bgColor: { type: String, default: "transparent" },
        iconColor: { type: String, default: undefined },
        padding: { type: String, default: "9px" },
        border: { type: String, default: "none" },
        hoveredBgColor: { type: String, default: "transparent" },
        hoveredIconColor: { type: String, default: undefined },
        width: { type: String, default: "15px" },
        height: { type: String, default: "15px" },
        radius: { type: String, default: "50%" },
    },
    data() {
        return {
            isHovered: false,
            hoveredFeature: false,
            svgHoveredColor: undefined,
        };
    },
    methods: {},
    mounted() {
        if (this.hoveredBgColor !== "transparent") {
            this.hoveredFeature = true;
        }
        if (this.hoveredIconColor) {
            this.svgHoveredColor = this.hoveredIconColor;
        }
    },
};
</script>

<style lang="scss">
.custom-icon-button {
    cursor: pointer;

    .custom-icon-container {
        display: flex;
        justify-content: center;
        align-items: center;
        transition: 300ms;

        div {
            display: flex;
            justify-content: center;
            align-items: center;
        }

        svg {
            margin: 0;
            padding: 0;
            transition: 500ms;
            width: 20px;
            height: 20px;

            path {
                transition: 300ms;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/common/IconButton.vue